var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 18.009C81.7875 18.063 87.0885 18.4995 90.5445 21.9555C94.5 25.911 94.5 32.274 94.5 45V72C94.5 84.7305 94.5 91.0935 90.5445 95.049C86.5935 99 80.226 99 67.5 99H40.5C27.774 99 21.4065 99 17.4555 95.049C13.5 91.089 13.5 84.7305 13.5 72V45C13.5 32.274 13.5 25.911 17.4555 21.9555C20.9115 18.4995 26.2125 18.063 36 18.009",
    stroke: "#333333",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 63H72M31.5 47.25H76.5M40.5 78.75H67.5",
    stroke: "#333333",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15.75C36 13.9598 36.7112 12.2429 37.977 10.977C39.2429 9.71116 40.9598 9 42.75 9H65.25C67.0402 9 68.7571 9.71116 70.023 10.977C71.2888 12.2429 72 13.9598 72 15.75V20.25C72 22.0402 71.2888 23.7571 70.023 25.023C68.7571 26.2888 67.0402 27 65.25 27H42.75C40.9598 27 39.2429 26.2888 37.977 25.023C36.7112 23.7571 36 22.0402 36 20.25V15.75Z",
    stroke: "#333333",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.7af0923acef9ba3b6cf1c7c69d7c4767.svg";
export { ForwardRef as ReactComponent };